import React from "react";

const Unauthorized = () => {
  return (
    <div className="p-10 text-center text-red-600 text-xl font-bold">
      Access Denied — You are not allowed to view this page.
    </div>
  );
};

export default Unauthorized;
